import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';

const QrSaleOrderModal = ({ open = false, onClose, imageUrl, code }) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(code);

    enqueueSnackbar('Texto copiado al portapapeles!', { variant: 'success' });
  }, [code, enqueueSnackbar]);

  return (
    <Dialog fullWidth maxWidth="xs" open={open}>
      <DialogTitle>QR en pesos Avanzado</DialogTitle>

      <DialogContent style={{ margin: 'auto' }}>
        <Box
          component="img"
          src={imageUrl}
          alt="QR en pesos Avanzado"
          width={200}
          height={200}
        />
      </DialogContent>

      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button onClick={onClose} color="default" variant="outlined">
          Cerrar
        </Button>

        <Button color="primary" variant="outlined" onClick={handleCopy}>
          Copiar al portapapeles
        </Button>
      </DialogActions>
    </Dialog>
  );
};

QrSaleOrderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string,
  code: PropTypes.string,
};

QrSaleOrderModal.defaultProps = {
  imageUrl: undefined,
  code: undefined,
};

export default QrSaleOrderModal;
